// extracted by mini-css-extract-plugin
export var equalColumn = "_fg-0";